import React from 'react';
import { Card } from '../shadcn-ui/card';
import { Label } from '../shadcn-ui/label';
import MediaGrid from '../sharedComponents/MediaGrid';
import MediaPicker from '../sharedComponents/MediaPicker';
import { cn } from '@/lib/utils';

const MediaUploader = ({ media, label = 'Media', onUploaded, children, className, loading = false }) => {
  return (
    <Card className={cn('my-3 overflow-hidden p-4', className)}>
      <Label className="text-base font-medium text-[hsl(var(--text-foreground))]">{label}</Label>

      <MediaPicker onAdd={media?.addFiles} disabled={media?.uploading} className={className} />

      {/* Image/Video map */}
      <div className="mt-4 flex gap-4">
        {children}
        <MediaGrid
          media={[...media?.uploadedMedia, ...media?.localMedia]}
          onRemove={media?.removeMedia}
          loading={loading}
        />
      </div>

      {/* expose upload via callback */}
      {/* {onUploaded && onUploaded(media.uploadAll)} */}
    </Card>
  );
};

export default MediaUploader;
